module.exports = __webpack_public_path__ + "img/lens-guide-cover-pace.7bdabd8.jpg";